import { render, staticRenderFns } from "./UiNotice.vue?vue&type=template&id=8200bbd8&scoped=true"
import script from "./UiNotice.vue?vue&type=script&lang=js"
export * from "./UiNotice.vue?vue&type=script&lang=js"
import style0 from "./UiNotice.vue?vue&type=style&index=0&id=8200bbd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_cache-loader@4.1.0_webpack@4.47.0_supports-_a02809e54f1429825a019cd6b08a4fe2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8200bbd8",
  null
  
)

export default component.exports